export const LevelType = {
  lossy: 'Extreme',
  lossy40: 'Balanced',
  lossless: 'Conservative',
};

export class IOPagesData {
  public url?: string;
  public date: any;
  public imagesCount: number;
  public imagesMode: string;
  public imagesSize: number;

  constructor(data) {
    this.url = data.page_url;
    this.date = data.date;
    this.imagesCount = data.images_count || 0;
    this.imagesMode = data.level = LevelType[data.level];
    this.imagesSize = data.images_size;
  }
}
